import { Button, Form, Grid, Input } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SubFormFilterField, SubFormFilterValues } from './type';
const { useBreakpoint } = Grid;
type RoleFilterFormProps = {
  formId: string;
  handleFilter: (values: SubFormFilterValues) => void;
  initialValues: SubFormFilterValues;
  closeModal?: () => void;
};

export const SubscriptionFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: RoleFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<SubFormFilterValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const onReset = () => {
    form.resetFields();
    handleFilter({ ...initialValues });
  };
  const onFinish = (formValues: SubFormFilterValues) => {
    handleFilter(formValues);
    closeModal?.();
  };

  return (
    <Form<SubFormFilterValues>
      id={formId}
      name={formId}
      className='filters-form'
      form={form}
      layout='vertical'
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper>
        <StandardItemsWrapper>
          <Form.Item<SubFormFilterValues>
            label={'Subscription Name'}
            name={SubFormFilterField.SubscriptionName}
          >
            <Input placeholder={'Enter Subscription'} />
          </Form.Item>
          {/* <Form.Item<SubFormFilterValues>
            label={'Status'}
            name={SubFormFilterField.Status}
          >
            <Select
              options={[
                { value: 'true', label: 'Active' },
                { value: 'false', label: 'InActive' },
              ]}
              placeholder={'Please select status'}
            />
          </Form.Item> */}
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>

      {screens.lg && (
        <ContentFilters.ButtonsWrapper>
          <Button type='primary' htmlType='submit'>
            {t('common.buttons.filter', { count: 1 })}
          </Button>
          <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
        </ContentFilters.ButtonsWrapper>
      )}
    </Form>
  );
};
